export default {"src":"/_next/static/media/feeling-support.colour.9c1eb515.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};